"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nativeApi_1 = require("./nativeApi");
var watchProperty_1 = require("./watchProperty");
/**
 * Adoption of nested node.
 */
function adoptChildNode(parent, node) {
    if (node.__unadopt) {
        node.__unadopt();
    }
    var nativeParent = node.parentNode;
    Object.defineProperty(node, 'nextSibling', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                return nativeApi_1.nextSiblingNative.get.call(node);
            }
            else {
                var i = Array.prototype.indexOf.call(parent.childNodes, node);
                return parent.childNodes[i + 1] || null; // the spec says it's null, not undefined
            }
        }
    });
    Object.defineProperty(node, 'nextElementSibling', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                return nativeApi_1.nextElementSiblingNative.get.call(node);
            }
            else {
                var i = Array.prototype.indexOf.call(parent.children, node);
                return parent.children[i + 1] || null;
            }
        }
    });
    Object.defineProperty(node, 'previousSibling', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                return nativeApi_1.previousSiblingNative.get.call(node);
            }
            else {
                var i = Array.prototype.indexOf.call(parent.childNodes, node);
                return parent.childNodes[i - 1] || null;
            }
        }
    });
    Object.defineProperty(node, 'previousElementSibling', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                return nativeApi_1.previousElementSiblingNative.get.call(node);
            }
            else {
                var i = Array.prototype.indexOf.call(parent.children, node);
                return parent.children[i - 1] || null;
            }
        }
    });
    Object.defineProperty(node, 'parentNode', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                if (nativeApi_1.parentNodeNative && nativeApi_1.parentNodeNative.get) {
                    return nativeApi_1.parentNodeNative.get.call(node);
                }
                else {
                    return nativeParent;
                }
            }
            else {
                return parent;
            }
        },
        set: function (n) {
            nativeParent = n;
        }
    });
    Object.defineProperty(node, 'parentElement', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                if (nativeApi_1.parentElementNative.get) {
                    return nativeApi_1.parentElementNative.get.call(node);
                }
                else {
                    return nativeParent;
                }
            }
            else {
                return parent;
            }
        },
        set: function (v) {
            nativeParent = v;
        }
    });
    Object.defineProperty(node, 'assignedSlot', {
        configurable: true,
        get: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                if (nativeApi_1.assignedSlotNative.get) {
                    return nativeApi_1.assignedSlotNative.get.call(node);
                }
                else {
                    return null;
                }
            }
            else {
                var assignedSlot = null;
                nativeApi_1.exposeNativeApi(true);
                if (node.parentNode && node.parentNode.tagName === 'SLOT') {
                    assignedSlot = node.parentNode;
                }
                nativeApi_1.exposeNativeApi(false);
                return assignedSlot;
            }
        },
        set: function (n) { }
    });
    Object.defineProperty(node, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function () {
            if (nativeApi_1.isNativeApiExposed()) {
                nativeApi_1.removeNative.value.call(this);
            }
            else {
                // cannot use parentNode.removeChild(this)
                // since domino uses node.remove() inside parentNode.removeChild
                var ce = this.parentNode; // parent will be different after unadoption
                unadoptChildNode(this.parentNode, this); // so domino will use original node.remove() method
                ce.removeChild(this); // remove this node from parent.childNodesArray
            }
        }
    });
    var unwatchSlot;
    if (node.nodeType === Node.ELEMENT_NODE) {
        unwatchSlot = watchProperty_1.watchProperty(node, 'slot', function () {
            var p = parent;
            unadoptChildNode(p, node);
            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
            adoptChildNode(p, node);
            p.slots = null;
            if (p.rendererCallback) {
                p.rendererCallback();
            }
        });
    }
    node.__unadopt = function () {
        if (nativeApi_1.parentNodeNative && nativeApi_1.parentNodeNative.get) {
            Object.defineProperty(node, 'parentNode', {
                configurable: true,
                get: nativeApi_1.parentNodeNative.get
            });
        }
        else {
            Object.defineProperty(node, 'parentNode', {
                configurable: true,
                writable: true,
                value: nativeParent
            });
        }
        var hasNativeParentElement = node.nodeType !== -1 && Node.prototype.hasOwnProperty('parentElement');
        if (nativeApi_1.parentElementNative && nativeApi_1.parentElementNative.get && hasNativeParentElement) {
            Object.defineProperty(node, 'parentElement', {
                configurable: true,
                get: nativeApi_1.parentElementNative.get
            });
        }
        else {
            Object.defineProperty(node, 'parentElement', {
                configurable: true,
                writable: true,
                value: nativeParent
            });
        }
        Object.defineProperty(node, 'previousSibling', {
            configurable: true,
            get: nativeApi_1.previousSiblingNative.get
        });
        Object.defineProperty(node, 'nextSibling', {
            configurable: true,
            get: nativeApi_1.nextSiblingNative.get
        });
        Object.defineProperty(node, 'previousElementSibling', {
            configurable: true,
            get: nativeApi_1.previousElementSiblingNative.get
        });
        Object.defineProperty(node, 'nextElementSibling', {
            configurable: true,
            get: nativeApi_1.nextElementSiblingNative.get
        });
        delete node.assignedSlot;
        if (nativeApi_1.removeNative) {
            Object.defineProperty(node, 'remove', {
                value: nativeApi_1.removeNative.value,
                writable: true,
                configurable: true
            });
        }
        else {
            delete node.remove; // clear our patching if there is no native method
        }
        if (unwatchSlot) {
            unwatchSlot();
        }
        delete node.__unadopt;
    };
}
exports.adoptChildNode = adoptChildNode;
function unadoptChildNode(parent, node) {
    /* istanbul ignore else */
    if (node.__unadopt) {
        node.__unadopt();
    }
}
exports.unadoptChildNode = unadoptChildNode;
